export default {
  报图完成: "报图完成",
  展位号: "展位号",
  面积: "面积",
  "报图已完成，等待工作人员审核": "报图已完成，等待工作人员审核。",
  "审核结果将会以邮件的形式发送到您的邮箱，请注意查收":
    "审核结果将会以邮件的形式发送到您的邮箱，请注意查收。",
  "如有疑问，请前往首页咨询相关负责人": "如有疑问，请前往首页咨询相关负责人",
  去缴费: "去缴费",
  结束报图: "结束报图"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingEnd.js